// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-i258r";
var _4 = "header-3XZh0";
var _5 = "desc-5pGji";
var _6 = "price-gY4Y3";
var _7 = "crossed-EjP9q";
var _8 = "buttons-p7_SU";
var _9 = "changeFlight-2w8_F";
var _a = "old_price-Dd2GC";
var _b = "price_lower-3w1Ut";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "header", _5 as "desc", _6 as "price", _7 as "crossed", _8 as "buttons", _9 as "changeFlight", _a as "old_price", _b as "price_lower" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "header": _4, "desc": _5, "price": _6, "crossed": _7, "buttons": _8, "changeFlight": _9, "old_price": _a, "price_lower": _b }
